var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"picture_item",style:({
  backgroundImage: 'url(' + _vm.src + ')',
  width: _vm.width,
  height: _vm.height,
  backgroundSize: _vm.backgroundSize,
  backgroundPosition: _vm.offsetHorizontal + ' ' + _vm.offsetVertical
})})}
var staticRenderFns = []

export { render, staticRenderFns }